import React from "react";
import { Container } from "reactstrap";
import _List from "./../_List";

import { connect } from "react-redux";
import { get, remove } from "./../../store/ducks/newsCategories";

import { ContentTable, Header } from "./../../components";

class NewsCategoriesList extends _List {
  render() {
    const { data } = this.props;

    return (
      <>
        <Header />
        <Container className="mt--7 bg-default" fluid>
          <ContentTable
            columns={[
              {
                title: "Título",
                slug: "title"
              },
              {
                title: "Status",
                slug: "status"
              }
            ]}
            data={data}
            hasInsert={false}
            middleware={row => {
              row.status = (
                <strong className={row.status ? "text-success" : "text-danger"}>
                  {row.status ? "Ativo" : "Inativo"}
                </strong>
              );

              return row;
            }}
          />
        </Container>
      </>
    );
  }
}

const mapStateToProps = ({ common, newsCategories }) => ({
  currentRoute: common.currentRoute,
  data: newsCategories.data,
  loading: newsCategories.loading,
  loadingBar: common.loadingBar
});

const mapDispatchToProps = {
  get,
  remove
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsCategoriesList);
